import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {NavLink} from 'react-router-dom'
import {routesUrls} from '../../settings/routes'
import cn from 'classnames'
import {createSelector} from 'reselect'
import {handleStep_clickCreateSubjectStep} from '../../modules/tutorial'
import {connect} from 'react-redux'
import { isOrganisationSelector, isTeacherOrganisationSelector } from '../../modules/profile'


class Submenu extends Component {
    render() {
        let {formatMessage} = this.context
        return (
            <div className={cn([
                "sub-menu",
                "sub-menu--height-sm",
                "sub-menu--border-bottom",
                "sub-menu--indent-bottom",
                "sub-menu--theme-default",
                "sub-menu--responsive-default",
            ])}>
                <ul className={cn([
                    "sub-menu__list",
                    "sub-menu__list--match-parent"
                ])}>
                    {
                        this.getSubmenuItems()
                            .map(({text, to, tag, onClick}) => {
                                const Tag = tag === "NavLink" ? NavLink : "span"
                                let tagProps = {
                                    className : cn([
                                        "sub-menu__link",
                                        "sub-menu__link--sm",
                                    ])
                                }
                                if (tag === 'NavLink') {
                                    tagProps = {
                                        ...tagProps,
                                        activeClassName : "sub-menu__link--active",
                                        to : to
                                    }
                                } else {
                                    tagProps = {
                                        ...tagProps,
                                        onClick,
                                    }
                                }
                                return (
                                    <li
                                        className={cn([
                                            "sub-menu__list-item",
                                            "sub-menu__list-item--indent-rspns",
                                        ])}
                                        key = {text}>
                                        <Tag
                                            {...tagProps}
                                        >{formatMessage(text)}</Tag>
                                    </li>
                                )
                            })
                    }
                </ul>
            </div>
        )
    }

    getSubmenuItems = createSelector(() => {
        let {handleStep_clickCreateSubjectStep, isOrganisation, isTeacherOrganisation} = this.props;

        if(isOrganisation){
            return Submenu.SUBMENUTITEMS;
        }
        return Submenu.SUBMENUTITEMS.filter(item => !(isTeacherOrganisation && item.text == 'subMenuTransactions') ).concat(
            {
                tag : "span",
                text : "Start tutorial",
                onClick : handleStep_clickCreateSubjectStep
            }
        )
    })

    static SUBMENUTITEMS = [
        {
            to : routesUrls.profile,
            text : "Profile",
            tag : "NavLink",
        },
        {
            to : routesUrls.referals,
            text : "subMenuReferal",
            tag : "NavLink",
        },
        {
            to : routesUrls.transactions,
            text : "subMenuTransactions",
            tag : "NavLink",
        },
        // {
        //     to : routesUrls.payment,
        //     text : "Donate to QBM",
        //     tag : "NavLink",
        // },
        {
            to : routesUrls.support,
            text : "Support",
            tag : "NavLink",
        }
    ]
}
Submenu.contextTypes = {formatMessage: PropTypes.any}

export default connect((state) => (
        {
            isOrganisation: isOrganisationSelector(state),
            isTeacherOrganisation: isTeacherOrganisationSelector(state),
        }
    ),
    { handleStep_clickCreateSubjectStep },
    null,
    {pure : false}
)(Submenu)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Submenu.js